import React, { useEffect, useState } from 'react';
import { ReactComponent as LoadingSpinnerIcon } from '../../assets/svgs/LoadingSpinner.svg';

export const LoadingSpinner = (props: {size?: number}) => {
  const defaultSize = 40;
  const [size, setSize] = useState<number>(defaultSize);

  useEffect(() => {
    if (props.size) {
      setSize(props.size)
    }
  }, []);

  return (<div
    style={{
      animation: "spin 1s linear infinite",
      transformOrigin: `${size / 2}px ${size / 2}px`,  // because the svg is 40px wide, we rotate about the centre (20px)
      height: size,
      width: size,
    }}>
    <LoadingSpinnerIcon width={size} height={size} />
  </div>)
}
export default LoadingSpinner;
